import { render, staticRenderFns } from "./ok-footer.vue?vue&type=template&id=71c9f562&scoped=true"
import script from "./ok-footer.vue?vue&type=script&lang=js"
export * from "./ok-footer.vue?vue&type=script&lang=js"
import style0 from "./ok-footer.vue?vue&type=style&index=0&id=71c9f562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c9f562",
  null
  
)

export default component.exports